/** 报表页通用：分页、CSV 导出、区域选项 */
import { resolveStatus } from '@/utils/statusTag'

export const REPORT_REGION_OPTIONS = ['浦东', '闵行', '徐汇', '黄浦', '静安']
export const REPORT_SITE_TYPE_OPTIONS = ['流量计', '调压设备']

function pad2(n) {
  return String(n).padStart(2, '0')
}

export function formatDateText(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date)
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
}

export function currentMonthText(date = new Date()) {
  return formatDateText(date).slice(0, 7)
}

export function currentYearText(date = new Date()) {
  return String(date.getFullYear())
}

export function formatDateTimeText(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date)
  return `${formatDateText(d)} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`
}

export function recentDateRange(days = 30) {
  const end = new Date()
  const start = new Date(end)
  start.setDate(end.getDate() - Math.max(days - 1, 0))
  return [formatDateText(start), formatDateText(end)]
}

export function recentDateTimeRange(days = 30) {
  const end = new Date()
  end.setHours(23, 59, 59, 0)
  const start = new Date(end)
  start.setDate(end.getDate() - Math.max(days - 1, 0))
  start.setHours(0, 0, 0, 0)
  return [formatDateTimeText(start), formatDateTimeText(end)]
}

export function formatNum(v) {
  if (v == null || v === '') return '0'
  const n = Number(v)
  if (Number.isNaN(n)) return String(v)
  return n.toLocaleString(undefined, { maximumFractionDigits: 2 })
}

export default {
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      statCards: [],
      regionOptions: REPORT_REGION_OPTIONS,
      siteTypeOptions: REPORT_SITE_TYPE_OPTIONS
    }
  },
  methods: {
    rowIndex(index, row) {
      const base = (this.query.pageNum - 1) * this.query.pageSize
      // 小计/合计行不占序号，数据行按页内数据行序连续编号
      if (row && row._dataRowNo) return base + row._dataRowNo
      return base + index + 1
    },
    buildQuery() {
      const p = { ...this.query }
      Object.keys(p).forEach(k => { if (p[k] === '' || p[k] === null) p[k] = undefined })
      return p
    },
    handleSizeChange(size) {
      this.query.pageSize = size
      this.query.pageNum = 1
      this.loadData()
    },
    handleCurrentChange(page) {
      this.query.pageNum = page
      this.loadData()
    },
    search() {
      this.query.pageNum = 1
      if (this.loadStats) this.loadStats()
      this.loadData()
    },
    reportDeviceName(row) {
      if (!row) return ''
      return row.deviceName || row.siteName || row.deviceCode || row.terminalCode || '-'
    },
    downloadCsv(rows, headers, rowMapper, filename) {
      if (!rows.length) {
        this.$message.warning('暂无数据可导出')
        return
      }
      const lines = [headers.map(this.csvCell).join(',')]
      rows.forEach(r => lines.push(rowMapper(r).map(this.csvCell).join(',')))
      const blob = new Blob(['\ufeff' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `${this.safeFileName(filename)}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
      this.$message.success('导出成功')
    },
    downloadPeriodDetailCsv(rows, mode, filename) {
      if (mode === 'yearly') {
        this.downloadCsv(rows,
          ['统计月份', '设备名称', '子设备', '上报天数', '月标况累积(m³)', '月均瞬时(m³/h)', '月工况累积(m³)', '月均压力(MPa)', '异常天数', '状态'],
          r => [r.monthLabel, this.reportDeviceName(r), r.subDeviceLabel || '', r.dayCount, r.stdTotalSum, r.stdInstantAvg, r.workTotalSum, r.pressureAvg, r.abnormalDays, this.statusLabel(r.recordStatus)],
          filename)
        return
      }
      this.downloadCsv(rows,
        ['统计日期', '设备名称', '子设备', '标况累积(m³)', '标况瞬时(m³/h)', '工况累积(m³)', '工况瞬时(m³/h)', '压力(Kpa)', '温度(℃)', '状态'],
        r => [r.reportDate, this.reportDeviceName(r), r.subDeviceLabel || '', r.stdTotal, r.stdInstant, r.workTotal, r.workInstant, r.pressure, r.temperature, this.statusLabel(r.recordStatus)],
        filename)
    },
    statusLabel(value) {
      return resolveStatus('reportRecord', value).label
    },
    dateText(value) {
      if (!value) return ''
      return String(value).slice(0, 10)
    },
    csvCell(value) {
      const text = value === null || value === undefined ? '' : String(value)
      return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
    },
    safeFileName(name) {
      return String(name || '导出数据').replace(/[\\/:*?"<>|]/g, '_')
    }
  }
}
